<template>
  <ModalTemplate
    v-if="product"
    :isVisible="isVisible"
    title="Деталі товару"
    @close="closeModal"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 h-">
      <!-- Left Column -->
      <div>
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">Назва</label>
          <input
            type="text"
            v-model="product.name"
            :disabled="readonlyInputs"
            :placeholder="readonlyInputs ? 'Назва продукту' : ''"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          />
        </div>

        <div v-if="isCard" class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">
            Кількість тренуваннь
          </label>
          <input
            type="number"
            v-model="product.trainings"
            :disabled="readonlyInputs"
            :placeholder="readonlyInputs ? 'Введіть кількість' : ''"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          />
        </div>

        <div v-if="isCard" class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">Строк дії</label>
          <input
            type="number"
            v-model="validityInput"
            :disabled="readonlyInputs"
            :placeholder="readonlyInputs ? 'Дні' : ''"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          />
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">Тип тренуваннь</label>
          <select
            v-model="product.training_type"
            :disabled="readonlyInputs"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          >
            <option
              v-for="option in groupOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">Ціна</label>
          <input
            type="number"
            v-model="product.cost"
            :disabled="readonlyInputs"
            :placeholder="readonlyInputs ? 'Ціна продукту' : ''"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          />
        </div>

        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 text-left">Опис</label>
          <textarea
            v-model="product.description"
            :disabled="readonlyInputs"
            :placeholder="readonlyInputs ? 'Опис продукту' : ''"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm p-1.5"
            :class="{'border-blue-500': !readonlyInputs}"
          ></textarea>
        </div>
      </div>

      <!-- Right Column -->
      <div class="text-center col-span-1 border-l p-2">
        <div class="mb-4">
          <button
            v-if="user[0].role === 'superadmin' && readonlyInputs"
            class="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 transition"
            @click="toggleInputs"
          >
            Редагувати
          </button>

          <button
            v-if="user[0].role === 'superadmin' && !readonlyInputs"
            class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
            :disabled="isSaving"
            @click="saveProduct"
          >
            <span v-if="isSaving">Збереження...</span>
            <span v-else>Зберегти</span>
          </button>
        </div>
        <!-- Search Bar -->

        <!-- Groups list -->
        <div
          v-if="isCard"
          class="mt-6"
        >
          <div class="mb-4" v-if="!readonlyInputs">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Search groups by name..."
              class="block w-full p-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <h3 class="text-lg font-semibold" v-if="product.allowed_groups && product.allowed_groups.length">Доступні групи:</h3>
          
          <ul class="space-y-2 mt-4" v-if="readonlyInputs">
            <li
              v-for="group in product.allowed_groups"
              :key="group.id"
              class="flex items-center justify-between px-4 py-2 rounded-lg bg-gray-100 shadow-sm hover:bg-gray-200 transition-colors"
            >
              <div class="flex items-center space-x-2">
                <!-- Optionally, you can add an icon or other indicator here -->
                <div class="text-left">
                <div class="font-medium text-gray-800">{{ group.name }}</div>
                <div class="text-sm text-gray-600">{{ group.daytime }}</div>
              </div>
              </div>
            </li>
          </ul>

          <div v-if="!readonlyInputs" class="overflow-y-auto h-80 overflow-x-hidden">

            <div 
                v-for="training in filteredGroups"
                :key="training.id"
                class="flex items-center justify-between p-4 mb-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 cursor-pointer"
                :class="{ 'bg-green-400': selectedGroups.includes(training.id) }"
                @click="toggleGroupSelection(training.id)"
              >
              <!-- Group Information -->
              <div class="text-left">
                <div class="font-medium text-gray-800">{{ training.name }}</div>
                <div class="text-sm text-gray-600">{{ training.daytime }}</div>
              </div>
            
              <!-- Checkbox -->
              <input
                type="checkbox"
                v-model="selectedGroups"
                :value="training.id"
                class="h-5 w-5 text-blue-500 focus:ring-blue-400 border-gray-300 rounded"
                @click.stop
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalTemplate>
</template>

<script>
import ModalTemplate from "../reusable/ModalTemplate.vue";
import { mapState } from "vuex";

export default {
  name: "ProductDetails",
  components: { ModalTemplate },
  props: {
    isCard: Boolean,
    productId: Number,
    isVisible: Boolean,
    currentProductType: Number,
  },
  data() {
    return {
      readonlyInputs: true,
      product: null,
      isSaving: false,
      groupOptions: [
        { value: 1, text: "Персональні" },
        { value: 2, text: "Групові" },
        { value: 3, text: "Зал" },
        { value: 4, text: "Масаж" },
      ],
      schedule: [],
      selectedGroups: [],
      searchQuery: ""
    };
  },
  watch: {
    productId: "fetchProduct", 
  },
  methods: {
    async fetchProduct() {
      try {
        const response = await this.$api.products.getProduct(this.productId);
        this.product = response.data;
        if (this.product.allowed_groups) {
          this.selectedGroups = this.product.allowed_groups.map((group) => group.id);
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    },
    async getSchedule () {
      try {
        const response = await this.$api.groups.getStaticSchedule();
        this.schedule = response.data.Schedule;
      } catch (error) {
        console.error("Error fetching groups:", error);
      }

    },
    async saveProduct() {
      try {
        this.isSaving = true;
        if (this.currentProductType === 1) {
          const groupsToUpdate = this.schedule.filter((group) => this.selectedGroups.includes(group.id));
          const groupIdsToUpdate = groupsToUpdate.map((group) => group.id);
          await this.$api.products.updateCard(this.product.id, { ...this.product, allowed_groups: groupIdsToUpdate });
          this.product.allowed_groups = groupsToUpdate;
        } else {
          await this.$api.products.updateSolo(this.product.id, this.product);
        }
        this.readonlyInputs = true;
        this.$emit("product-updated");
      } catch (error) {
        console.error("Error updating product:", error);
      } finally {
        this.isSaving = false;
      }
    },
    toggleInputs() {
      this.readonlyInputs = !this.readonlyInputs;
      if (!this.readonlyInputs) {
        this.$nextTick(() => {
          this.$el.querySelector("input").focus();
        });
      }
    },
    toggleGroupSelection(groupId) {
      if (this.selectedGroups.includes(groupId)) {
        this.selectedGroups = this.selectedGroups.filter((id) => id !== groupId);
      } else {
        this.selectedGroups.push(groupId);
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapState(["user"]),
    filteredGroups() {
      if (!this.searchQuery.trim()) {
        return this.schedule; // If search query is empty, return all groups
      }
      const query = this.searchQuery.trim().toLowerCase();
      return this.schedule.filter((group) =>
        group.name.toLowerCase().includes(query)
      );
    },
    validityInput: {
      get() {
        return this.product.validity;
      },
      set(value) {
        this.product.validity = Number(value); // Force conversion to number
      }
    }
  },
  async mounted() {
    if (this.productId) {
      await this.fetchProduct();
      await this.getSchedule();
    }
  },
};
</script>
